import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

import { pluralize } from "core/strings";

import Icon from "ui/atom/Icon";
import Box from "ui/atom/Box";
import Button from "ui/base/Button";

import { useStart } from "features/start/fabric";
import { useContentUnlock } from "areas/unlock/fabric";


export default function Wallet () {
	const content = useContentUnlock();
	const start = useStart();
	const theme = useTheme();

	const isCampaign = Boolean(content.data?.campaignBalance);

	const profile = start.profile;
	const color = content.insufficient ? "error" : "coin";

	const balance = (() => {
		if (isCampaign) return ({ value: content.data?.campaignBalance, label: "Campaign" });
		else return ({ value: profile?.balance, label: "Subly" });
	})();

	const style = {
		root: { width: "100%" },
		wallet: {
			width: "100%",
			height: 42,
			justifyContent: "space-between", alignItems: "center",
			pl: theme.spacing(2),
			borderRadius: "16px",
			border: "1px solid",
			borderColor: theme.palette[color]?.main
		},
		content: { alignItems: "center" },
		text: { alignItems: "center" },
		insufficient: { textAlign: "center" }
	};

	return (
		<Box.Column gap={1} sx={style.root}>
			{content.insufficient && <Typography variant="h4" color="error.main" sx={style.insufficient}>You have insufficient tokens!</Typography>}
			<Box sx={style.wallet}>
				<Box gap={1.25} sx={style.content}>
					<Icon name="wallet" size={18} />
					<Box gap={0.625} sx={style.text}>
						<Typography variant="body3">You have</Typography>
						<Icon name={isCampaign ? "campaign-coin" : "coin"} size={9} />
						<Typography variant="body3" fontWeight={700} color={color}>
							{pluralize(balance.value, `${balance.label} token`)}
						</Typography>
					</Box>
				</Box>
				{!isCampaign && <Button color={color} size="small" onClick={content.getMore}>Get more</Button>}
			</Box>
		</Box.Column>
	);
};